module.exports = __webpack_public_path__ + "static/media/handshake.abf4dc7a.svg";